import LungReferralImage from "assets/images/lungReferralImage.png";
import ProstateReferralImage from "assets/images/prostateReferral.png";

import { ReferralPreview } from "../../../ReferralPreview/ReferralPreview";
import { ItemFormWrapper } from "../ItemFormWrapper/ItemFormWrapper";

export const ReviewForm = ({
  data,
  onBack,
  onSendReferral,
  isPending,
  isProstateReferral,
  isLungReferral,
}) => {
  return (
    <>
      {isProstateReferral && (
        <img
          src={ProstateReferralImage}
          alt="national rapid access prostate clinic referral form"
        />
      )}
      {isLungReferral && (
        <img
          src={LungReferralImage}
          alt="National lung cancer rapid access service referral form"
        />
      )}
      <ItemFormWrapper
        onBack={onBack}
        onContinue={onSendReferral}
        continueText={isPending ? "Sending..." : "Send Referral"}
        disabled={isPending}
      >
        <ReferralPreview
          data={data}
          isProstateReferral={isProstateReferral}
          isLungReferral={isLungReferral}
        />
      </ItemFormWrapper>
    </>
  );
};
